export const tableTitle = {
  manageThresholdValues: "Manage Threshold Values ",
  inventoryHistory: "Purchased Inventory History",
  availableInventory: "Available Inventory List",
  issueInventory: "Issued Inventory History",
  returnedInventory: "Returned Inventory History",
  discardedInventory: "Discarded Inventory list",
  repairedInventory: "Need Repair Inventory List",
  inventorytHandoverList: "Inventory Handover List",
  inventoryHandoverReceivedList: "Received Inventory List",
};

export const manageThreshold: string[] = [
  "Project Name",
  "Item Name",
  "Item Quantity",
  "Unit of Item",
  "Std Consumption/meter",
  "Updated at",
  "Action",
];
export const inventoryHistory: string[] = [
  "Item Added on",
  "Item Name",
  "Quantity of Item",
  "Unit of Item",
  "Inventory Type",
  "Purchased  from",
  "Bill Reference Number",
  "Basic Rate (Rs)",
  "Amount of Item (A) (Rs)",
  "GST on Item (B) (%)",
  "Deduction of Item amount (C) (Rs)",
  "Gross Item Amount (D=A+A*B%-C) (included GST)",
  "Description",
  "Gross Deduction Amount (Rs)",
  "Gross Bill Amount (Rs)",
];

export const availableInventory: string[] = [
  "Item Name",
  "Item in Stock",
  "Unit of Item",
  "Inventory Type",
  "Threshold Quantity",
  "Item Purchase Requirement",
];

export const issueInventory: string[] = [
  "Item Name",
  "Item Issue Date and Time",
  "Quantity of Item",
  "Unit of Item",
  "Inventory Type",
  "Issue Slip Snapshot",
  "Machine Details",
  "Main Category",
  "Issued To (Sub-Category)",
];
export const returnInventory: string[] = [
  "Item Name",
  "Item Received Date and Time",
  "Quantity of Item",
  "Unit of Item",
  "Inventory Type",
  "Item Condition",
  "Returned Item Slip Snapshot",
  "Issued Main Category",
  "Issued to (Sub-Category)",
  "Return Main Category",
  "Returned by (Sub-Category)",
  "Debit Impose",
];
export const discardedInventory: string[] = [
  "Item Name",
  "Item Received Date and Time",
  "Quantity of Item",
  "Unit of Item",
  "Originally Issued to",
  "Returned Item Snapshot",
  "Returned Item Slip Snapshot",
  "Main Category",
  "Returned by (Sub-Category)",
  "Debit Impose",
];
export const repairInventory: string[] = [
  "Item Name",
  "Item Received Date and Time",
  "Quantity of Item",
  "Unit of Item",
  "Originally Issued to",
  "Returned Item Snapshot",
  "Main Category",
  "Returned by (Sub-Category)",
];
export const inventoryHandovered: string[] = [
  "Item Name",
  "Quantity of Item",
  "Unit of Item",
  "Handover From",
  "Handover To",
  "Handover Date",
  "Shift of Receiving Engineer",
  "Reason",
  "Request Status",
];
export const inventoryHandoverReceive: string[] = [
  "Item Name",
  "Quantity of Item",
  "Unit of Item",
  "Received From",
  "Received to",
  "Received Date",
  "Shift of Receiving Engineer",
  "Reason",
  "Request Status",
];

export const PILE_STEP_NAMES = [
  "Step 1. Casing",
  "Step 2. Boring",
  "Step 3. Cage Lowering",
  "Step 4. Tremie Lowering",
  "Step 5. Pile Forecasting",
  "Step 6. Area Cleaning",
  "Step 7. Concreting",
  "Step 8. Completed",
];
